import Vue from 'vue';

const defaultState = {
	destination: null,
	email: null,
	hasSubmitted: false,
	firstName: null,
	keyword: '',
	isContinue: false,
	lastName: null,
	moveDate: null,
	moveSize: {
		key: '1 bedroom',
		type: 'apartment',
		value: '1',
	},
	origin: null,
	phone: null,
	platform: null,
	referrer: null,
	source: 'tm',
	textVerifyId: null,
	year: null,
	make: null,
	model: null,
};

const state = Object.assign({}, defaultState, {
	tokens: {},
});

export const getters = {
	locationSplit: state => location => {
		const locationObj = state[location];

		return {
			[location]: locationObj.value,
			[`${location}_city`]: locationObj.city,
			[`${location}_state`]: locationObj.state,
			[`${location}_zip`]: locationObj.zipcode,
		};
	},
};
export const actions = {
	init({ dispatch, state, rootState }, routeData) {
		this._vm.$log.info('routeData -> ', routeData);

		// 'query' comes from the $route object
		const urlQuery = routeData.query;

		let autoToken = process.env.VUE_APP_TOKEN_AUTO;
		let moveToken = process.env.VUE_APP_TOKEN_MOVE;

		if (rootState.iframeFlag === 'usam') {
			autoToken = 'e0adb720-5124-11e7-b735-036116b86e4e';
			moveToken = '8ceec730-552d-11e7-9dc9-550f0c62b872';
		}

		try {
			const browserData = {
				...{},
				...{
					keyword: '',
					platform: window.navigator.platform || '',
					referrer: document.referrer || window.location.href,
					source: rootState.iframeFlag || 'tm',
				},
				...urlQuery,
			};

			this._vm.$log.debug('browserData -> ', browserData);

			const quoteFromStorage = this._vm.$session.get('quote');

			// Equivalent to using Object.assign({}, ...)
			const leadData = {
				...{},
				...state,
				...browserData,
				...quoteFromStorage,
			};

			// If there is no leadToken in the user's storage we need to generate new lead id
			let tokenAttempt = 0;

			if (!leadData.tokens.move && tokenAttempt < 5) {
				setTimeout(() => {
					dispatch('generateLeadToken', {
						type: 'auto',
						token: autoToken,
					});
					dispatch('generateLeadToken', {
						type: 'move',
						token: moveToken,
					});
					tokenAttempt++;
				}, 200);
				tokenAttempt++;
			}

			return dispatch('update', leadData);
		} catch (err) {
			this._vm.$log.error('getItem(quote)->', err);

			return Promise.reject(err);
		}
	},

	async generateLeadToken({ commit }, payload) {
		this._vm.$log.debug('generateLeadToken->', payload);

		const token = payload.token;

		if (!payload.type) {
			throw new Error('ERROR: Missing "type" property!');
		}

		const apiData = {
			'valet-token': token,
		};

		try {
			const res = await this._vm.$ireloApi.post('/hello', apiData);

			Vue.$log.debug('generateLeadToken->', res);

			if (res.status !== 200 || !res.data) {
				throw new Error('Failed to generate lead token.' + res.data);
			}

			const leadToken = res.data.lead_token;

			this._vm.$log.debug('await/generateLeadToken->', leadToken);

			// Ensure that we have a leadToken for the user
			if (!leadToken) {
				throw new Error('Empty leadToken!');
			}

			if (payload.type === 'move') {
				this._vm.$analytics.identify(leadToken, null);
			}

			return commit('SET_TOKEN', {
				type: payload.type,
				leadToken,
			});
		} catch (err) {
			throw new Error(err);
		}
	},

	getExistingLeadData({ commit }, payload) {
		let leadData = {};
		const leadToken = payload.leadToken;
		const valetToken = process.env.VUE_APP_TOKEN_MOVE;

		return new Promise((resolve, reject) => {
			this._vm.$ireloApi
				.get(`/lead/${leadToken}?valet-token=${valetToken}`)
				.then(resp => {
					this._vm.$log.info('getExistingLeadData | ', resp.data);

					leadData = resp.data;

					leadData.isContinue = true;

					if (leadData.hasOwnProperty('leadToken')) {
						commit('SET_TOKEN', { type: 'move', ...leadData });
					}

					commit('UPDATE', leadData);

					resolve(leadData);
				})
				.catch(resp => {
					this._vm.$log.warn('getExistingLeadData | ', resp);

					reject(resp);
				});
		});
	},

	submitLead({ dispatch, state }, payload) {
		Vue.$log.info('submitLead->', state);

		const submitType = payload.isResubmit ? 'resubmit' : 'submit';
		const leadType = payload.leadType || 'move';
		const token = state.tokens[leadType];

		const url = `/lead/${submitType}`;
		const leadData = {
			leadToken: token,
			...state,
		};

		if (leadType === 'auto') {
			leadData.parent_lead_id = state.tokens.move;
			leadData.source = 'tm_mmc';
			delete leadData.moveSize;
		}

		delete leadData.textVerifyId;
		delete leadData.tokens;

		this._vm.$analytics.identify(state.tokens.move, {
			first_name: state.firstName,
			last_name: state.lastName,
			email: state.email,
			phone: state.phone,
		});

		return new Promise((resolve, reject) => {
			this._vm.$ireloApi.post(url, leadData)
				.then(resp => {
					if (resp.data.status === 'success') {
						// Don't trigger the conversion again if it's being resubmitted
						if (!payload.isResubmit) {
							dispatch('triggerConversion', { leadType, submitType });
						}

						resolve(resp.data);
					} else {
						reject(resp.data);
					}
				})
				.catch(resp => {
					reject(resp);
				});
		});
	},

	triggerConversion({ state, rootState }, payload) {
		const isAutoLead = payload.leadType === 'auto';
		const token = state.tokens[payload.leadType];
		const source = isAutoLead ? 'tm_mmc' : state.source;
		let trackName = payload.submitType === 'submit' ? 'conversion' : 'resend';

		if (state.isContinue) {
			trackName += 'Abandon';
		}

		if (isAutoLead) {
			trackName = 'autoLead';
		}

		Vue.$log.info('triggerConversion ->', payload, trackName);

		this._vm.$analytics.track(trackName, {
			email: state.email,
			source,
			token,
		});

		if (rootState.iframeFlag && window.gtag) {
			const gtagData = {
				event_category: 'lead',
				event_label: source,
				value: token,
			};

			Vue.$log.info('Google Analytics track | ', gtagData);
			window.gtag('event', 'submit', gtagData);
		}
	},

	update({ commit, state }, payload) {
		const newQuote = Object.assign({}, state, payload);

		this._vm.$log.info('quote:update', payload, newQuote);

		try {
			commit('UPDATE', newQuote);

			return new Promise((resolve, reject) => {
				try {
					this._vm.$session.set('quote', newQuote);
					resolve(newQuote);
				} catch (err) {
					reject(err);
				}
			});
		} catch (err) {
			this._vm.$log.error('quote/update | ', err);

			return Promise.reject(err);
		}
	},
};

export const mutations = {
	SET_TOKEN: (state, payload) => {
		return Vue.set(state.tokens, payload.type, payload.leadToken);
	},
	UPDATE: (state, payload) => {
		Vue.$log.debug(state, payload);

		for (const prop in payload) {
			if (state.hasOwnProperty(prop)) {
				state[prop] = payload[prop];
			} else {
				Vue.$log.warn(`'${prop}' is not defined in state!`);
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
